export const CURRENT_CONFIG = {

  // license
  appId: '156232',
  appKey: '6a1c88a99d685106fb1ef98506e94b5',
  appLicense: 'UnUsxbipEK6EBya344iYwwTFUD5lGL/xPGQw7Lg17BbguX0xIQt2wMnsXuKXaLku+faI/DwKZB4nzYZDO/AVB6l5RHupacz8L5ZrVzxNnIHe9jXH46+Em3YilncHHZSUwFqqLSUWZtzPp/Fq+EdEnrM1J2V6tUEBZaxTumSQwbI=',

  // http
  baseURL: 'https://dji.fctdrones.com/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://dji.fctdrones.com/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'
  // mission planner drafts + KMZ publish (PHP, CORS-enabled for this origin)
  missionApiURL: 'https://fctdrones.com/mission_api.php',

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://95.111.247.208/live/', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  googleMapKey: 'AIzaSyAocwxdSxmzjog_aqNVCjdOwgJ3h_KT1RI',

}
